// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__vf6dh","title":"ClientInsurance_title__2whb7","itemText":"ClientInsurance_itemText__u-utz"};